import { always, compose, converge, ifElse, isEmpty, not, path } from 'ramda';

import { isDirectToPay, userLocale } from 'app/features/user/selectors';
import { OFFER_INELIGIBLE_PATH } from 'app/router/constants/paths';
import localizeLink from 'app/features/localization/localizeLink';
import { coupon } from 'app/features/couponCampaign/selectors';

const redirectUrl = converge(localizeLink, [
  ifElse(isDirectToPay, always(OFFER_INELIGIBLE_PATH), always(null)),
  userLocale,
]);

const heroBlockProps = compose(path(['landing', 'heroBlock']), coupon);

const heroBlockDarkProps = compose(path(['landing', 'heroBlockDark']), coupon);

const isHeroBlockDark = compose(not, isEmpty, heroBlockDarkProps);

export { redirectUrl, heroBlockProps, heroBlockDarkProps, isHeroBlockDark };
